module.exports = __webpack_public_path__ + "static/img/img_5.d9d32017.jpg";